export default __webpack_public_path__ + "assets/cf5dfe299612bff7d4394751c81d152d.png";